module.exports = __webpack_public_path__ + "e6357f8e80628ab251c74487316c4873.svg";